
export default class EmbeddedGallery 
{
	
	
	
	constructor(element) 
	{
		this.target = element;
		this.items = element.querySelector('.eg--thumbnails');
		this.thumbs = element.querySelectorAll('.eg--thumbnail');
		this.total = this.thumbs.length;
		this.current = 0;
		
		if( this.total < 2 ) {
			return;
		}
		
		this.initialize();
	}
	
	
	
	initialize() 
	{
		const _this = this;
		
		this.target.classList.add('eg--enabled');
		
		
		['eg--prev', 'eg--next'].forEach(c => {
			const b = document.createElement('button');
			b.setAttribute('type', 'button');
			b.classList.add(c);
			_this.target.appendChild(b);
		})
		
		const prev = this.target.querySelector('.eg--prev');
		if(prev) {
			prev.addEventListener('click', event => {
				let _next = _this.current - 1;
				if( _next < 0 ) {
					_next = _this.total - 1;
				}
				_this.goto(_next);
			});
		}
		
		const next = this.target.querySelector('.eg--next');
		if(next) {
			next.addEventListener('click', event => {
				let _next = _this.current + 1;
				if( _next > _this.total - 1 ) {
					_next = 0;
				}
				_this.goto(_next);
			});
		}
	}
	
	
	
	
	goto(next) 
	{
		this.target.classList.remove('eg--current-'+ this.current);
		this.target.classList.add('eg--current-'+ next);
		this.current = next;
	}
}